<template>
  <v-row>
    <LoadingDialog v-if="loading" :is_loading="loading"></LoadingDialog>
    <v-col cols="12" align-self="center">
      <v-card elevation="2" outlined>
        <v-card>
          <v-tabs v-model="tabs" background-color="#eeeeee" centered>
            <v-tab v-for="n in tab_items" :key="n" @click="setTab(n)">
              {{ n }}
            </v-tab>
          </v-tabs>
        </v-card>

        <v-tabs-items v-model="tabs">
          <!-- TAB : Datasource -->
          <v-tab-item>
            <v-row>
              <v-col cols="6">
                <v-card-text rounded class="text-center">
                  <h3 class="mb-2">&nbsp;</h3>
                  <v-select
                    v-model="datasource_name"
                    :items="datasource_list"
                    label="Available Datasource"
                    dense
                    @change="setJSONDatasourceEditor"
                  ></v-select>
                </v-card-text>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-card-text rounded>
                  <h3 class="mb-2">Query parameters</h3>
                  <vue-json-editor
                    v-model="ds_query_param"
                    mode="code"
                    :modes="['tree', 'code']"
                    :show-btns="false"
                    :expandedOnStart="true"
                  ></vue-json-editor>
                  <br />
                  <v-btn
                    depressed
                    color="primary"
                    @click="refreshJSONDatasourceEditor"
                  >
                    Refresh data
                  </v-btn>
                </v-card-text>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-card-text rounded>
                  <div>
                    <h3 class="mb-2">Datasource Content</h3>
                    <vue-json-editor
                      v-if="!loading"
                      v-model="datasource_content"
                      mode="tree"
                      :modes="['tree', 'code']"
                      :show-btns="false"
                      :expandedOnStart="false"
                    ></vue-json-editor>
                  </div>
                </v-card-text>
              </v-col>
            </v-row>
          </v-tab-item>

          <!-- TAB : Template -->
          <v-tab-item>
            <v-row>
              <v-col cols="6">
                <br />
                <v-list>
                  <v-list-item>
                    <v-select
                      v-model="report_idx"
                      :items="report_list"
                      label="Report template list"
                      dense
                      @change="setJSONEditor"
                    ></v-select>

                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="mx-2"
                          fab
                          dark
                          small
                          color="primary"
                          v-bind="attrs"
                          v-on="on"
                          @click="add_dialog = true"
                        >
                          <v-icon dark> mdi-plus </v-icon>
                        </v-btn>
                      </template>
                      <span>Add a new template report</span>
                    </v-tooltip>

                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="mx-2"
                          fab
                          dark
                          small
                          color="green"
                          v-bind="attrs"
                          v-on="on"
                          @click="updateTemplateReport"
                        >
                          <v-icon dark> mdi-content-save </v-icon>
                        </v-btn>
                      </template>
                      <span>Save a template report</span>
                    </v-tooltip>

                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="mx-2"
                          fab
                          dark
                          small
                          color="red"
                          v-bind="attrs"
                          v-on="on"
                          @click="del_dialog = true"
                        >
                          <v-icon dark> mdi-delete </v-icon>
                        </v-btn>
                      </template>
                      <span>Delete a template report</span>
                    </v-tooltip>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-card-text rounded>
                  <div>
                    <h3 class="mb-2">Query parameters</h3>
                    <vue-json-editor
                      v-model="query_param"
                      mode="code"
                      :modes="['tree', 'code']"
                      :show-btns="false"
                      :expandedOnStart="true"
                    ></vue-json-editor>
                  </div>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text rounded>
                  <div>
                    <h3 class="mb-2">Datasource / Options</h3>
                    <vue-json-editor
                      v-model="option"
                      mode="code"
                      :modes="['tree', 'code']"
                      :show-btns="false"
                      :expandedOnStart="true"
                      @json-change="onOptionChange"
                    ></vue-json-editor>
                  </div>
                </v-card-text>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-card-text rounded>
                  <h3 class="mb-2">Data</h3>
                  <vue-json-editor
                    v-model="data"
                    mode="code"
                    :modes="['tree', 'code']"
                    :show-btns="false"
                    :expandedOnStart="true"
                    @json-change="onDataChange"
                  ></vue-json-editor>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text rounded>
                  <div>
                    <h3 class="mb-2">Layout</h3>
                    <vue-json-editor
                      v-model="layout"
                      mode="code"
                      :modes="['tree', 'code']"
                      :show-btns="false"
                      :expandedOnStart="true"
                      @json-change="onLayoutChange"
                    ></vue-json-editor>
                  </div>
                </v-card-text>
              </v-col>
            </v-row>
          </v-tab-item>

          <!-- TAB : Graph -->
          <v-tab-item>
            <v-row>
              <v-col v-if="show_graph && !loading" cols="12">
                <v-card-text rounded class="text-center">
                  <plotly
                    ref="graph"
                    :data="data_render"
                    :layout="layout_render"
                    :displayModeBar="true"
                  />
                </v-card-text>
              </v-col>
            </v-row>
            <v-row>
              <v-col v-if="show_graph && !loading" cols="6">
                <v-card-text rounded>
                  <h3 class="mb-2">Data Render</h3>
                  <vue-json-editor
                    v-model="data_render"
                    mode="tree"
                    :modes="['tree', 'code']"
                    :show-btns="false"
                    :expandedOnStart="true"
                  ></vue-json-editor>
                </v-card-text>
              </v-col>
              <v-col v-if="show_graph && !loading" cols="6">
                <v-card-text rounded>
                  <div>
                    <h3 class="mb-2">Layout Render</h3>
                    <vue-json-editor
                      v-model="layout_render"
                      mode="tree"
                      :modes="['tree', 'code']"
                      :show-btns="false"
                      :expandedOnStart="true"
                    ></vue-json-editor>
                  </div>
                </v-card-text>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </v-card>

      <!-- Add Dialog box -->
      <v-dialog v-model="add_dialog" persistent max-width="500">
        <v-card>
          <v-card-title class="text-h6"> Add a new template </v-card-title>
          <v-card-text>
            <v-text-field
              v-model="dialog_report_name"
              label="Report name"
              dense
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              color="primary"
              @click="addNewTemplateReport(dialog_report_name)"
              >Add</v-btn
            >
            <v-btn depressed color="error" @click="add_dialog = false"
              >Cancel</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Delete Dialog box -->
      <v-dialog v-model="del_dialog" persistent max-width="500">
        <v-card>
          <v-card-title class="text-h6">
            Delete a template report
          </v-card-title>
          <v-card-text>
            Do you really wants to delete this template report from database ?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn depressed color="primary" @click="deleteTemplateReport()"
              >Delete</v-btn
            >
            <v-btn depressed color="error" @click="del_dialog = false"
              >Cancel</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Notifications -->
      <v-snackbar v-model="notif_bar" :color="notif_color" :timeout="timeout">
        {{ notif_text }}

        <template v-slot:action="{ attrs }">
          <v-btn color="blue" text v-bind="attrs" @click="notif_bar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </v-col>
  </v-row>
</template>

<script>
import api from "../api/api";
import { Plotly } from "vue-plotly";
import vueJsonEditor from "vue-json-editor";
import LoadingDialog from "@/components/Utils/LoadingDialog";
import { mapGetters } from "vuex";

export default {
  components: {
    Plotly,
    vueJsonEditor,
    LoadingDialog,
  },
  data() {
    return {
      add_dialog: false,
      datasource_content: {},
      datasource_name: null,
      datasource_list: [],
      del_dialog: false,
      dialog_report_name: "",
      loading: false,
      notif_bar: false,
      notif_color: "black",
      notif_text: "",
      tabs: null,
      report_idx: null,
      report_list: [],
      show_datasource: false,
      show_template: false,
      show_graph: false,
      tab_items: ["Datasource", "Template", "Graph"],
      template_report: [],
      timeout: 2000,
      data: [{}],
      layout: {},
      option: {},
      ds_query_param: {
        datasource_name: "",
        installation_id: 272,
        start_date: "2021-05-27",
        end_date: "2021-07-27",
        date_interval: "daily",
        sel_pdm: null,
        export_type: "2D_datetime",
        pn_type: "site"
     
      },
      query_param: {
        installation_id: 272,
        start_date: "2021-05-27",
        end_date: "2021-07-27",
        date_interval: "daily",
        sel_pdm: null,
        export_type: null,
        pn_type: "site",
        pacgrid: false
      },
      data_render: [{}],
      layout_render: {},
    };
  },

  created() {
    this.getTemplateReportList();
    this.datasource_list = this.getReportDS();
  },

  mounted() {
    this.$store.commit("SET_CUR_INSTALL_ID", null);
  },

  computed: {
    ...mapGetters({
      cur_install_id: "cur_install_id",
      installations: "installations",
    }),
  },

  methods: {
    setTab(id) {
      this.show_datasource = id === "Datasource";
      this.show_template = id === "Template";
      this.show_graph = id === "Graph";

      if (this.report_idx !== null) {
        if (this.show_datasource || this.show_template) {
          if (this.show_datasource) this.getReportDS();
          this.loading = false;
        }
        if (this.show_graph) this.renderModel();
      }
    },

    async getReportDS() {
      await api.getReportDatasource().then((res) => {
        this.datasource_list = res.data;
      });
    },

    async renderModel() {
      this.loading = true;
      const lang_code = this.$root.$i18n.locale;
      const report_name = `${
        this.template_report[this.report_idx]["report_name"]
      } - graph${String(this.template_report[this.report_idx]["graph_id"])}`;

      this.query_param.pacgrid = this.installations.some(
        (site) =>
          this.query_param.installation_id === Number(site.installation_id) &&
          site.elec_var.includes("Pac@grid")
      );
     
      await api
        .getTemplateRenderByName(report_name, lang_code, this.query_param)
        .then((res) => {
          this.data_render = res["data"]["data"];
          this.layout_render = res["data"]["layout"];
          this.loading = false;
        });
    },

    async getTemplateReportList() {
      // Get template list from report table
      this.loading = true;

      await api.getReportList().then((res) => {
        let i = 0;
        Object.entries(res["data"]).forEach((elm) => {
          this.template_report.push({
            id: elm[1]["id"],
            report_name: elm[1]["report_name"],
            graph_id: elm[1]["graph_id"],
            data: elm[1]["data"]["data"],
            layout: elm[1]["data"]["layout"],
            option: elm[1]["option"],
            data_render: [{}],
            layout_render: {},
          });
          this.report_list.push({
            text: `${elm[1]["report_name"]} - graph${String(
              elm[1]["graph_id"]
            )}`,
            value: i,
          });
          i++;
        });
        this.loading = false;
      });

      this.setJSONEditor(null);

      this.loading = false;
    },

    setJSONEditor(value) {
      // Set data into JSON editors from report table

      if (value !== null) {
        this.report_idx = value;
        this.data = this.template_report[value]["data"];
        this.layout = this.template_report[value]["layout"];
        this.option = this.template_report[value]["option"];
        this.data_render = this.template_report[value]["data_render"];
        this.layout_render = this.template_report[value]["layout_render"];
      }
    },

    async refreshJSONDatasourceEditor() {
      this.loading = true;
      await api.getGraphDatasource(this.ds_query_param).then((res) => {
        this.datasource_content = res["data"];
        this.loading = false;
      });
    },

    async setJSONDatasourceEditor(value) {
      if (value !== null) {
        this.ds_query_param["datasource_name"] = value;
        this.refreshJSONDatasourceEditor();
      }
    },

    onDataChange(value) {
      // On Data JSON editor change
      this.template_report[this.report_idx]["data"] = value;
    },

    onLayoutChange(value) {
      // On Layout JSON editor change
      this.template_report[this.report_idx]["layout"] = value;
    },

    onOptionChange(value) {
      // On Option JSON editor change
      this.template_report[this.report_idx]["option"] = value;
    },

    async addNewTemplateReport(reportName) {
      // Initialize a new template report

      if (this.dialog_report_name.length > 0) {
        this.add_dialog = false;

        // Calculate max graph_id
        let maxGraphID =
          Math.max.apply(
            Math,
            this.template_report
              .filter((o) => o.report_name === reportName)
              .map((o) => o.graph_id)
          ) + 1;

        if (!isFinite(maxGraphID)) maxGraphID = 1;

        this.report_list.push({
          text: `${reportName} - graph${String(maxGraphID)}`,
          value: this.report_list.length,
        });

        this.template_report.push({
          report_name: reportName,
          graph_id: maxGraphID,
          data: [{}],
          layout: {},
          option: {},
          data_render: {},
          layout_render: {},
        });

        this.setJSONEditor(this.template_report.length - 1);

        const item = this.template_report[this.report_idx];
        const newRec = {
          report_name: item["report_name"],
          graph_id: item["graph_id"],
          data: {
            data: item["data"],
            layout: item["layout"],
          },
          option: item["option"],
        };

        await api
          .addNewReport(newRec)
          .then(() => {
            this.timeout = 2000;
            this.notif_text = "The empty template report has been added";
            this.notif_color = "#77c27a";
            this.notif_bar = true;
            this.getTemplateReportList();
          })
          .catch((err) => {
            this.timeout = 5000;
            this.notif_text = err;
            this.notif_color = "#f44336";
            this.notif_bar = true;
          });
      }
    },

    async updateTemplateReport() {
      // Update the current template report in database

      const item = this.template_report[this.report_idx];
      const updRec = {
        id: item["id"],
        report_name: item["report_name"],
        graph_id: item["graph_id"],
        data: {
          data: item["data"],
          layout: item["layout"],
        },
        option: item["option"],
      };

      await api
        .updateReport(updRec)
        .then(() => {
          this.timeout = 2000;
          this.notif_text = "The template report has been updated";
          this.notif_color = "#77c27a";
          this.notif_bar = true;
        })
        .catch((err) => {
          this.timeout = 5000;
          this.notif_text = err;
          this.notif_color = "#f44336";
          this.notif_bar = true;
        });
    },

    async deleteTemplateReport() {
      // Delete the current template report into database

      await api
        .deleteReport(this.template_report[this.report_idx])
        .then(() => {
          this.timeout = 2000;
          this.notif_text = "The template report has been deleted";
          this.notif_color = "#77c27a";
          this.notif_bar = true;
        })
        .catch((err) => {
          this.timeout = 5000;
          this.notif_text = err;
          this.notif_color = "#f44336";
          this.notif_bar = true;
        });

      this.del_dialog = false;

      // Reload template report list and initialize editor
      this.report_list = [];
      this.template_report = [];
      this.report_idx = null;
      this.data = [{}];
      this.layout = {};
      this.option = {};

      await this.getTemplateReportList();
    },
  },
};
</script>

<style></style>
